import objectFitImages from 'object-fit-images';

document.addEventListener('DOMContentLoaded', () => { objectFitImages(); });
